<div class="overlay-window-footer">
  <brt-button [title]="'Schließen'" [size]="'large'" [color]="'inherit'" (click)="onClosed.emit(true)"></brt-button>
</div>
